$(function() {

    $('.custom-selects .select select').each(function(idx, el){

        var _el = $(el);

        var selectedText = _el.find('option:selected').text();
        _el.parent().attr('data-content', selectedText);

        _el.on('change', function(e) {
            var _select = $(e.target);
            var selectedText = _select.find('option:selected').text();
            _select.parent().attr('data-content', selectedText);
        });
    });

});